"use client";
import { SupText } from "@repo/core-ui";
import React from "react";
import { twMerge } from "tailwind-merge";

interface CTAProps {
  className?: string;
  topChild: string | React.ReactNode;
  bottomChild: React.ReactNode;
}

export default function CTA({ className, topChild, bottomChild }: CTAProps) {
  return (
    <div className={twMerge("divide-y divide-primary-500 overflow-hidden rounded-3xl rounded-tr-none border-0.5 border-primary-600 text-center", className)}>
      <div className="py-4">
        <SupText as="div" className="uppercase text-primary-900" family="mono" variant="body1" weight="bold" style={{ textShadow: "2px 2px 4px rgba(137, 121, 217, 0.70)" }}>
          {topChild}
        </SupText>
      </div>
      <div className="bg-primary-50 py-3">
        <SupText as="div" className="h-10 uppercase text-primary-800" variant="body1" family="mono">
          {bottomChild}
        </SupText>
      </div>
    </div>
  );
}
